import AICloudDeveloperPage from "./AICloudDeveloperPage";

export default function DataAnalystPage() {
  return <AICloudDeveloperPage technology="data-analyst" />;
}
